import { User } from 'lib-shared-types-api';
import { PureComponent } from 'react';

import { MessageStatus } from '../messageStatus';

type PropsT = {
  /** The message object */
  message: any;
};

export default class StatusUnassigned extends PureComponent<PropsT> {
  constructor(props: PropsT) {
    super(props);
  }

  generateStatusText(author: User) {
    const { name, phone_number, email } = author;

    const text = 'was unassigned from the conversation';

    if (name && name.trim().length) {
      return `${name} ${text}`;
    }
    return `${phone_number || email} ${text}`;
  }

  render() {
    const { message, ...otherProps } = this.props;

    return (
      <MessageStatus
        {...(otherProps as any)}
        text={this.generateStatusText(message.author)}
      />
    );
  }
}
